module.exports = "/_next/static/chunks/fonts/HindMadurai-Bold-af3eace3a4fd1daac529e7a6cbd96eb5.woff2";